import { render, staticRenderFns } from "./PayPurchaseCourse.vue?vue&type=template&id=db053e46&scoped=true"
import script from "./PayPurchaseCourse.vue?vue&type=script&lang=js"
export * from "./PayPurchaseCourse.vue?vue&type=script&lang=js"
import style0 from "./PayPurchaseCourse.vue?vue&type=style&index=0&id=db053e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db053e46",
  null
  
)

export default component.exports